import moment from 'moment';
import i18n from '../../common/i18n';

export const formatMatchDate = someDate => {
    const today = moment();
    const tomorrow = moment().add(1, 'day');
    const isToday = date => date.isSame(today, 'day');
    const isTomorrow = date => date.isSame(tomorrow, 'day');
    const time = moment(someDate).format('HH:mm');

    if (isToday(moment(someDate))) {
        return i18n('nui.date.today') + ' ' + time;
    } else if (isTomorrow(moment(someDate))) {
        return i18n('nui.date.tomorrow') + ' ' + time;
    } else return moment(someDate).format('D.M.') + ' - ' + time;
};

// extract either logo or flag for a team participants of a specific match
export const getParticipantsIcons = participants => {
    const icons: { homeUrl?: string; awayUrl?: string } = {};
    const teamParticipants = participants?.filter(participant => participant.participantType === 'team');

    if (teamParticipants?.length === 2) {
        const homeParticipant = teamParticipants[0];
        const awayParticipant = teamParticipants[1];

        const { flags: homeFlags, teamLogos: homeLogos } = homeParticipant?.icons || {};
        const { flags: awayFlags, teamLogos: awayLogos } = awayParticipant?.icons || {};

        const homeFlag = homeFlags?.[0].flag;
        const awayFlag = awayFlags?.[0].flag;
        const homeLogo = homeLogos?.[0].teamLogo;
        const awayLogo = awayLogos?.[0].teamLogo;

        if (homeLogo && awayLogo) {
            icons.homeUrl = homeLogo;
            icons.awayUrl = awayLogo;
        } else if (homeFlag && awayFlag) {
            icons.homeUrl = homeFlag;
            icons.awayUrl = awayFlag;
        }
    }
    return icons;
};

export const sortHeadersEnabledFirst = (headers, bets) =>
    headers?.sort((firstHeader, secondHeader) => {
        const areFirstHeaderBetsEnabled = firstHeader.get('betIds').every(betId => bets?.has(`${betId}`));
        const areSecondHeaderBetsEnabled = secondHeader.get('betIds').every(betId => bets?.has(`${betId}`));

        if (!areFirstHeaderBetsEnabled && areSecondHeaderBetsEnabled) return 1;
        else if (!areSecondHeaderBetsEnabled && areFirstHeaderBetsEnabled) return -1;
        else return 0;
    });
